import React from 'react';
import type { Row } from '../data/tables';
type ComparisonTableProps = {
  rows: Row[];
  leftLabel: string;
  rightLabel: string;
  /** 'affirm' highlights the right column in sage; 'warn' marks it as a cost. */
  variant?: 'affirm' | 'warn';
  className?: string;
};

/**
 * Two-column comparison. On phones each pair becomes its own labelled card —
 * a 50/50 table at 375px squeezes both sides into unreadable columns.
 */
export function ComparisonTable({
  rows,
  leftLabel,
  rightLabel,
  variant = 'affirm',
  className = ''
}: ComparisonTableProps) {
  const rightAccent = variant === 'warn' ? 'text-flag-red' : 'text-sage';
  const rightHeaderBg = variant === 'warn' ? '' : 'bg-sage-soft';
  const rightCellBg = variant === 'warn' ? '' : 'bg-sage-soft/40';
  return <div className={className} data-id="element-79" data-mp="1wz5pqxsgm9n7">
      <ul className="space-y-3 sm:hidden" data-id="element-80" data-mp="1wxur1cdvfs2y">
        {rows.map(([left, right]) => <li key={left} className="rounded-2xl border border-sage/15 bg-white p-5 shadow-card" data-id="element-81" data-mp="21y8wcmo38nxa">
            <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-muted" data-id="element-82" data-mp="2dxxfspw7pin9">
              {leftLabel}
            </p>
            <p className="mt-1.5 font-sans text-[15px] leading-[1.5] text-ink-soft" data-id="element-83" data-mp="2nvbjrq0y8eyo">{left}</p>

            <div className="mt-4 border-t border-sage/15 pt-4" data-id="element-84" data-mp="2iwrxtpmcv36b">
              <p className={`font-sans text-[11px] font-semibold uppercase tracking-[0.12em] ${rightAccent}`} data-id="element-85" data-mp="2iyl7zew6g5j2">
                {rightLabel}
              </p>
              <p className="mt-1.5 font-sans text-[15px] font-medium leading-[1.5] text-ink" data-id="element-86" data-mp="2sufuwm7fomrn">
                {right}
              </p>
            </div>
          </li>)}
      </ul>

      <div className="hidden overflow-hidden rounded-2xl border border-sage/15 bg-white shadow-card sm:block" data-id="element-87" data-mp="31ob3y5boexck">
        <table className="w-full border-collapse text-left" data-id="element-88" data-mp="3gkil0wrsfinm">
          <thead data-id="element-89" data-mp="3blyxwt1gk0to">
            <tr data-id="element-90" data-mp="3bmh006asx99i">
              <th scope="col" className="w-1/2 border-b border-sage/15 px-5 py-4 font-sans text-[12px] font-semibold uppercase tracking-[0.12em] text-ink-muted sm:px-7" data-id="element-91" data-mp="3bn0jhrg3o5pn">
                {leftLabel}
              </th>
              <th scope="col" className={`w-1/2 border-b border-l border-sage/15 px-5 py-4 font-sans text-[12px] font-semibold uppercase tracking-[0.12em] sm:px-7 ${rightAccent} ${rightHeaderBg}`} data-id="element-92" data-mp="3sma75uxer0p6">
                {rightLabel}
              </th>
            </tr>
          </thead>
          <tbody data-id="element-93" data-mp="a6zk6wg037b3">
            {rows.map(([left, right]) => <tr key={left} className="border-b border-sage/10 last:border-0" data-id="element-94" data-mp="f7dt0gpfela6">
                <td className="px-5 py-4 align-top font-sans text-[15px] leading-snug text-ink-soft sm:px-7" data-id="element-95" data-mp="k6i2l8g9il11">
                  {left}
                </td>
                <td className={`border-l border-sage/15 px-5 py-4 align-top font-sans text-[15px] font-medium leading-snug text-ink sm:px-7 ${rightCellBg}`} data-id="element-96" data-mp="2h0uybdq33a1r">
                  {right}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}